/**
 * Application scripts bundle — mirrors legacy Grunt script order (see git history) + missing route controllers.
 */
require('../../app/styles/font.css');
require('../../app/styles/bootstrap.min.css');
require('../../app/styles/xeditable.css');
require('../../app/styles/custom.css');
require('../../app/styles/jmesa.css');
require('../../app/styles/global.css');
require('../../app/styles/app.css');

require('../../app/scripts/obligorApp.js');
require('../../app/scripts/directive/navLoginDrc.js');
require('../../app/scripts/directive/footerDrc.js');
require('../../app/scripts/directive/navDrc.js');

require('../../app/scripts/controllers/login.js');
require('../../app/scripts/controllers/navCtrl.js');
require('../../app/scripts/controllers/viewUserProfileCtrl.js');

require('../../app/scripts/services/auth.js');
require('../../app/scripts/services/authtoken.js');
require('../../app/scripts/services/feeService.js');
require('../../app/scripts/services/profile.js');
require('../../app/scripts/services/state.js');
require('../../app/scripts/services/register.js');
require('../../app/scripts/services/bankManagement.js');
require('../../app/scripts/services/paymentResource.js');
require('../../app/scripts/services/caseResource.js');
require('../../app/scripts/services/reportsResource.js');
require('../../app/scripts/services/fipsResource.js');

require('../../app/scripts/controllers/logout.js');
require('../../app/scripts/controllers/fee.js');
require('../../app/scripts/controllers/password.js');
require('../../app/scripts/controllers/profile.js');
require('../../app/scripts/controllers/register.js');
require('../../app/scripts/controllers/main.js');
require('../../app/scripts/controllers/registerFinish.js');
require('../../app/scripts/controllers/static.js');
require('../../app/scripts/controllers/bank.js');
require('../../app/scripts/controllers/bankUpdate.js');
require('../../app/scripts/controllers/bankVerification.js');
require('../../app/scripts/controllers/bankCreate.js');
require('../../app/scripts/controllers/bankVerify.js');
require('../../app/scripts/controllers/bankNOC.js');
require('../../app/scripts/controllers/case.js');
require('../../app/scripts/controllers/caseEdit.js');
require('../../app/scripts/controllers/casemath.js');
require('../../app/scripts/controllers/caseVerification.js');
require('../../app/scripts/controllers/caseAddVerification.js');
require('../../app/scripts/controllers/payment.js');
require('../../app/scripts/controllers/viewPayment.js');
require('../../app/scripts/controllers/reports.js');
require('../../app/scripts/controllers/makePayment.js');
require('../../app/scripts/controllers/editPayment.js');
require('../../app/scripts/controllers/customSuccessErrorDialogCtrl.js');
require('../../app/scripts/controllers/selectCase.js');
require('../../app/scripts/controllers/paymentFrequencyCtrl.js');
require('../../app/scripts/controllers/paymentVerificationCtrl.js');
require('../../app/scripts/controllers/thankYouCtrl.js');
require('../../app/scripts/controllers/casePossible.js');
require('../../app/scripts/controllers/editWarning.js');
require('../../app/scripts/controllers/passwordChange.js');
require('../../app/scripts/controllers/managecard.js');
require('../../app/scripts/controllers/updatePayPal.js');

require('../../app/scripts/controllers/navigation.js');
require('../../app/scripts/directive/navbar.js');

require('../../app/scripts/factory/registerFactory.js');
require('../../app/scripts/factory/bankFactory.js');
require('../../app/scripts/factory/bankNocFactory.js');
require('../../app/scripts/factory/caseFactory.js');
require('../../app/scripts/factory/paymentFactory.js');
require('../../app/scripts/factory/reportsFactory.js');
require('../../app/scripts/factory/profileDetailFactory.js');
require('../../app/scripts/factory/errorFactory.js');
require('../../app/scripts/factory/actionFactory.js');
require('../../app/scripts/factory/messageFactory.js');
require('../../app/scripts/factory/profileFactory.js');
